<template>
  <div
    class="flex"
    :class="{ 'opacity-50': mainComment.resolved }"
  >
    <!-- this is the left vertical bar for threads -->
    <div
      v-if="replies.length"
      class="relative left-[14px] border-r-2 border-slate-200"
    >
            &nbsp;
    </div>
    <div class="flex flex-col flex-1 gap-3">
      <div :class="editingMainComment ? 'ml-10' : ''">
        <amoq-comment
          v-if="!editingMainComment"
          :comment="{
            authorName: mainComment.author.name,
            createdAt: mainComment.createdAt,
            updatedAt: mainComment.updatedAt,
            content: mainComment.content,
            mainComment: true,
            resolved: mainComment.resolved,
            resolvedAt: mainComment.resolvedAt,
            hasReplies: true,
          }"
          :is-author="$store.auth.authenticatedUser.id === mainComment.author.id
          "
          @resolve-toggle-changed="handleResolveToggle($event)"
          @reply-button-clicked="handleMainCommentReplyButtonClick"
          @delete-button-clicked="handleMainCommentDeleteButtonClick"
          @edit-button-clicked="handleMainCommentEditButtonClick"
        />
        <tip-tap-input
          v-else
          :mentionable-users="mentionableUsers"
          :auto-focus="true"
          :always-show-cancel-button="true"
          :value="mainComment.content"
          @save-button-clicked="handleMainCommentSaveButtonClick($event)"
          @cancel-button-click="handleMainCommentCancelButtonClick"
          @selected-ids="taggedIds = $event"
        />
      </div>
      <div class="flex gap-2 pl-10">
        <div class="flex flex-col w-full gap-2">
          <div
            v-for="(comment, index) in replies"
            :key="`comments-${index}`"
          >
            <amoq-comment
              v-if="replyBeingEdited !== index"
              :comment="{
                authorName: comment.author.name,
                createdAt: comment.createdAt,
                updatedAt: comment.updatedAt,
                content: comment.content,
                mainComment: false,
                resolved: mainComment.resolved,
              }"
              :is-author="$store.auth.authenticatedUser.id === comment.author.id
              "
              @reply-button-clicked="handleReplyCommentReplyButtonClick($event)"
              @delete-button-clicked="
                handleReplyCommentDeleteButtonClick($event, index)
              "
              @edit-button-clicked="
                handleReplyCommentEditButtonClick($event, index)
              "
            />
            <tip-tap-input
              v-else
              :auto-focus="true"
              :mentionable-users="mentionableUsers"
              :always-show-cancel-button="true"
              :value="comment.content"
              @save-button-clicked="
                handleReplyCommentSaveButtonClick($event, index)
              "
              @cancel-button-click="handleReplyCommentCancelButtonClick"
              @selected-ids="taggedIds = $event"
            />
          </div>
          <tip-tap-input
            v-if="replyMode"
            :mentionable-users="mentionableUsers"
            :always-show-cancel-button="true"
            @save-button-clicked="handleNewCommentSaveButtonClicked"
            @cancel-button-click="handleNewCommentCancelButtonClick"
            @selected-ids="taggedIds = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmoqCommentThread',

  props: {
    mainComment: {
      type: Object,
      default: () => ({
        author: {
          name: '',
          id: null,
        },
        content: '',
        createdAt: '',
        updatedAt: '',
        resolved: false,
        resolvedAt: '',
      }),
      required: true,
    },
    replies: {
      type: Array,
      default: () => [],
    },
    mentionableUsers: {
      type: Array,
      default: () => [],
    },
  },

  emits: [
    'main-comment-deleted',
    'comment-thread-resolve-value-changed',
    'new-reply-comment-added',
    'click',
    'main-comment-save-button-click',
    'reply-comment-edited',
    'reply-comment-deleted',
    'selected-user',
  ],

  data() {
    return {
      replyMode: false,
      newCommentBody: '',
      replyBeingEdited: null,
      editingMainComment: false,
      taggedIds: [],
    }
  },

  methods: {
    resetEditState() {
      this.replyBeingEdited = null
      this.editingMainComment = false
    },
    handleMainCommentSaveButtonClick(val) {
      this.$emit('main-comment-save-button-click', val)
      this.$emit('selected-user', this.taggedIds)
      this.resetEditState()
      this.replyMode = false
    },
    handleMainCommentCancelButtonClick() {
      this.resetEditState()
    },
    handleReplyCommentSaveButtonClick(val, replyIndex) {
      this.$emit('reply-comment-edited', val, replyIndex)
      this.resetEditState()
    },
    handleReplyCommentEditButtonClick(_, index) {
      this.resetEditState()
      this.replyBeingEdited = index
    },
    handleReplyCommentDeleteButtonClick(_, index) {
      this.$emit('reply-comment-deleted', index)
    },
    handleReplyCommentReplyButtonClick(_) {
      this.replyMode = true
    },
    handleReplyCommentCancelButtonClick() {
      this.resetEditState()
    },
    handleMainCommentReplyButtonClick() {
      this.replyMode = true
    },
    handleMainCommentEditButtonClick() {
      this.resetEditState()
      this.editingMainComment = true
    },
    handleMainCommentDeleteButtonClick() {
      this.$emit('main-comment-deleted')
    },
    handleResolveToggle(value) {
      this.$emit('comment-thread-resolve-value-changed', value)
    },
    handleNewCommentCancelButtonClick() {
      this.replyMode = false
    },
    handleNewCommentSaveButtonClicked(content) {
      this.$emit('new-reply-comment-added', content)
      this.replyMode = false
    },
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
